export const prioritySort = (a, b, greaterFirst) => {
  const priority = a.priority - b.priority;

  if (greaterFirst) {
    return -priority;
  }

  return priority;
};
